import {Location} from '@angular/common';
import {AnalyticsService} from '../../shared/services/analytics/analytics.service';
import {EventEnum, PathUrlEnum} from '../../utils/analytics.utils';
import {AuthenticationService} from '../../shared/services/authentication/authentication.service';
import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ErrorMessage} from '../../shared/models/error-message';
import {IProposal} from '../../shared/interfaces/IProposal';
import {ProposalMessageEnum} from '../../shared/enums/proposalMessage.enum';
import {validatorCNPJ, validatorCPF} from '../../utils/validators';
import {StatusService,} from '../../shared/services/authentication/status.service';
import {environment} from '../../../environments/environment';
import CpfHelper from '../../helpers/cpf.helper';
import NumberHelper from '../../helpers/number.helper';
import {RouteUtils} from "../../utils/route.utils";

@Component({
  selector: 'app-login-proposal',
  templateUrl: './login-proposal.component.html',
  styleUrls: ['./login-proposal.component.scss'],
})
export class LoginProposalComponent implements OnInit {
  formularioLogin: FormGroup;
  showError = false;
  errorMessage = ProposalMessageEnum.ERROR;
  proposal: IProposal;
  cpfMessageValidation: string;
  imgIntroUrl = environment.assetsRoot + '/logo-intro.png' || '';

  // START :: Methods Used in Html
  maskCpfCnpj = CpfHelper.maskCpfCnpj;
  numericOnly = NumberHelper.numericOnlyFromEvent;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private statusService: StatusService,
    private analyticsService: AnalyticsService,
    private location: Location
  ) {
  }

  ngOnInit(): void {
    this.formularioLogin = new FormGroup({
      proposal: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(8),
        ]),
      ),
      cpfCnpj: new FormControl('', Validators.required),
    });
    this.analyticsService.track(PathUrlEnum.LOGIN);
  }

  checkValidCpfCnpj() {
    this.formularioLogin.controls.cpfCnpj.value.length <= 11
      ? this.isRequired('cpfCnpj', [Validators.required, validatorCPF])
      : this.isRequired('cpfCnpj', [Validators.required, validatorCNPJ]);
  }

  isRequired(formulario: string, validadores: ValidatorFn[] | null = null) {
    return [
      this.formularioLogin.controls[formulario].setValidators(validadores),
      this.formularioLogin.controls[formulario].updateValueAndValidity(),
    ];
  }

  onSubmit(): void {
    this.analyticsService.trackEvent(PathUrlEnum.LOGIN, EventEnum.BTN_BUSCAR);
    this.cpfMessageValidation = 'campo obrigatório';
    this.recaptchaAuthorization();
    this.setIsLoading(true);
  }

  getErrorInvalid(label: string): string {
    return ErrorMessage.getTextInvalid(label);
  }

  private goToFormList(): void {
    this.setIsLoading(false);
    this.router.navigateByUrl(RouteUtils.PAGES.FORM_LIST);
  }

  recaptchaAuthorization() {
    sessionStorage.clear();
  localStorage.clear();

  setTimeout(() => {
    this.authenticationService.login(
      {
        documentNumber: this.formularioLogin.controls['cpfCnpj'].value.trim(),
        proposalNumber: this.formularioLogin.controls['proposal'].value.trim(),
      },
      () => {
        this.setShowError(false);
        this.goToFormList();
      },
      () => {
        this.setIsLoading(false);
        this.setShowError(true);
      },
    );
  }, 1000)

  }

  setIsLoading(isLoading: boolean) {
    this.statusService.isLoading = isLoading;
  }

  setShowError(showError: boolean) {
    this.showError = showError;
  }

  onLoadImageCatchError() {
    this.imgIntroUrl = '';
  }

  goBack(): void {
    this.analyticsService.trackEvent(PathUrlEnum.LOGIN, EventEnum.BTN_VOLTAR);
    this.location.back();
  }

}
